import React from 'react'
import './CardTable.scss'

interface FarmTypeCardProps {
  globalName: string;
  imageUrl: string;
  data?: any;
  handleCardClick?: (rowData: any) => void;
}

const FarmTypeCard: React.FC<FarmTypeCardProps> = ({
  globalName,
  imageUrl,
  data,
  handleCardClick
}) => {
  const onCardClick = () => {
    if (handleCardClick) {
      handleCardClick(data)
    }
  }

  return (
    <div
      className="farm-type-card"
      style={{ backgroundImage: `url(${imageUrl})` }}
      onClick={onCardClick}
      role="button"
      tabIndex={0}
      onKeyPress={(event) => {
        if (event.key === 'Enter') onCardClick()
      }}
    >
      <div className="farm-type-card-overlay">
        <div className="farm-type-card-header">
          <h3>{globalName}</h3>
        </div>
      </div>
    </div>
  )
}

export default FarmTypeCard
